import globalTheme from 'Assets/js/components/globalTheme';
import axios from 'axios';

export default function backInStock(variantId, email) {
  const data = {
    email,
    variant_id: variantId.replace('gid://shopify/ProductVariant/', ''),
    service_url: globalTheme.shopify().url
  };

  if (!data.email || !data.variant_id) {
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line prefer-promise-reject-errors
      reject({
        status: 404,
        error: 'Missing email or variant ID'
      });
    });
  }

  const config = {
    method: 'post',
    url: `${globalTheme.shopifyBackInStock()}/product-subscribers`,
    headers: {
      'Content-Type': 'application/json'
    },
    withCredentials: false,
    data: JSON.stringify(data)
  };

  return axios(config);
}
